import {authenticateUser, getUserPremiumLevel} from '@Libraries/user.library';

window.PMW.mergePMW(PMW, {
  /**
   * Shows the login modal if user is not logged in
   * @param {function} [onUserLoggedIn] callback that fires if user is logged in or logs in from the login modal that appears
   * @param {function} [onModalClose] callback that fires on modal close
   * @returns {Object}
   */
  authenticateUser(onUserLoggedIn = $.noop, onModalClose = $.noop) {
    return authenticateUser(onUserLoggedIn, onModalClose);
  },
  /**
   * Gets the
   * @return {Number}
   */
  getUserPremiumLevel() {
    return getUserPremiumLevel();
  },
});
